import DisplayDetailArticle from "../components/DisplayDetailArticle";
import Navigation from "../components/Navigation";
import New_C_Footer_2025_V2 from "../components/footer_automatic_files/Layout";
import New_C_Footer_Without_Testimony_2025_V2 from "../components/footer_automatic_files/Layout_Without_Testimony";
import New_C_Header_2025_V2 from "../components/header_automatic_files/Header";

import New_Navigation_2025 from "../components/New_Navigation_2025";

export default function displaydetailclass() {
    return (
        <div>
            <New_Navigation_2025 />
            <New_C_Header_2025_V2 />

            <DisplayDetailArticle />

            <New_C_Footer_Without_Testimony_2025_V2 />

        </div>
    );
}